import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";

export default class V1GroupReadied extends BaseIncomingPayload {
  public readonly payload: V1GroupReadiedPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_GROUP_READIED);

    this.payload = new V1GroupReadiedPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1GroupReadiedPayload {
  public readonly group_id: string;

  constructor(payload: Record<string, unknown>) {
    this.group_id = ParseUtils.parseString(payload, "group_id");
  }
}
